import { Theme, alpha } from '@mui/material/styles';

export const web3InteractionSuccessStyles = (
  theme: Theme,
  isDark: boolean
) => ({
  container: {
    [theme.breakpoints.down('md')]: {
      height: '100%'
    },
    [theme.breakpoints.up('md')]: {
      mt: '50px',
      height: '100%',
      width: '50%'
    },
    background: isDark
      ? `radial-gradient(circle at 10% 10%, ${alpha(
          theme.palette.primary.main,
          0.52
        )} 2%, ${
          theme.palette.background.default
        } 28%, transparent),radial-gradient(circle at 70% 80%, ${alpha(
          theme.palette.primary.main,
          0.3
        )} 2%, ${theme.palette.background.default} 28%) `
      : `radial-gradient(circle at 10% 12%, ${alpha(
          theme.palette.primary.main,
          0.22
        )} 2%, ${
          theme.palette.background.default
        } 28%, transparent),radial-gradient(circle at 70% 80%, ${alpha(
          theme.palette.primary.main,
          0.5
        )} 2%, ${theme.palette.background.default} 40%) `,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    height: 'auto',
    top: 0,
    [theme.breakpoints.up('sm')]: {},
    [theme.breakpoints.up('md')]: {
      pr: 0
    }
  },
  title: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 400",
    p: 1,
    pb: 2.5
  },
  paperContainerSummary: {
    px: 4,
    py: 4,
    mt: 0,
    ml: 0,
    minHeight: '30vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    width: '85vw',
    [theme.breakpoints.up('sm')]: { mb: 6 },
    [theme.breakpoints.down('sm')]: {
      my: 2,
      minHeight: 300,
      px: 2.5,
      py: 2,
      width: `calc(100% - 40px)`
    },
    [theme.breakpoints.up('lg')]: {
      width: '40vw',
      minHeight: '60vh',
      mb: 1
    },
    background: isDark
      ? 'linear-gradient(rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.07))'
      : 'rgba(233, 240, 253, 0.5)',
    boxShadow: isDark
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : 'rgb(0 0 0 / 7%) 0px 8px 13px 2px',
    backdropFilter: 'blur(40px)'
  },
  contentContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      p: 0,
      m: 0
    }
  },
  backIconColumn: {
    mr: 2
  },
  backIcon: {
    px: 0,
    pl: 1,
    pr: 1
  },
  buttonContained: {
    mt: 1,
    backgroundColor: theme.palette.primary.main,
    backgroundImage: 'none',
    '&:hover': {
      backgroundPosition: 'none',
      backgroundColor: alpha(theme.palette.primary.main, 0.06),
      transition: `background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
      color: theme.palette.primary.main,
      boxShadow: 'none'
    }
  },
  customContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '70vh'
  },
  txDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      m: 0
    }
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    pl: 7,
    pt: 3
  },
  gifBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    mt: 1,
    [theme.breakpoints.down('md')]: {
      mt: 0
    }
  },
  contentWrapper: {
    [theme.breakpoints.down('md')]: {
      m: 0
    }
  }
});
